import { OptionItem } from './OptionItem';
import { ProbabilityBtn } from './ProbabilityBtn';
import { SearchSvg } from './SearchSvg';

export const Randoms = ({ randoms, isGemType }: { randoms: Array<Array<{ name: string; origin: string }>>; isGemType: boolean }) => {
    if (!randoms?.length) return null;
    if (isGemType) {
        return (
            <ul>
                {randoms.map((randomGroup, groupIndex) =>
                    randomGroup.map((item, itemIndex) => (
                        <li key={`randoms-${groupIndex}-${itemIndex}`} className="has-button">
                            <div className="value add-btns">
                                <OptionItem name={item.name} origin={item.origin} />
                                <ProbabilityBtn isOrangeType={true} />
                            </div>
                        </li>
                    ))
                )}
            </ul>
        );
    }
    return (
        <ul>
            <li>
                <div className="value sub-ability">
                    보조 능력치 {randoms.length}개
                    <button data-tooltip-id="my-tooltip_sub-ability">
                        <SearchSvg />
                    </button>
                </div>
                <ProbabilityBtn />
            </li>
        </ul>
    );
};
